module.exports = __webpack_public_path__ + "static/author-kyle-senger-a8785bf23663db70b397f63a03661cd0.png";